import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuth } from "../../store/selectors";

const PrivateRoute = () => {
  const isAuth = useSelector(selectIsAuth);
  return isAuth === false ? (
    <Navigate to="/authorization" replace />
  ) : (
    <Outlet />
  );
};

// eslint-disable-next-line import/no-default-export
export default PrivateRoute;
